module.exports = __webpack_public_path__ + "static/media/tut-6.9ec20b77.png";